module.exports = __webpack_public_path__ + "static/media/foodmap-desktop.4143d5eb.jpeg";